import { useQuery } from '@tanstack/react-query';

import { courseConst, getCourses, ICourse, SortsType } from 'modules/courses';
import { IWithPagination } from 'modules/global';

export const useCourseSort = ({ sortByCreatedAt, sortByPrice, sortByRating, size }: SortsType) =>
  useQuery<IWithPagination<ICourse[]>>({
    queryKey: [courseConst.queryKeys.SORT_COURSES, sortByCreatedAt, sortByPrice, sortByRating, size],
    queryFn: getCourses({ sortByCreatedAt, sortByRating, sortByPrice, size })
  });
